module.exports = __webpack_public_path__ + "components/flag/static/square/bt-0e16eab23a4b2460f25ffe9a8b8f93a0.svg";